module.exports = __webpack_public_path__ + "img/result_msg_btn.72f1e526.png";